import { render, staticRenderFns } from "./UsersGroupIcon.vue?vue&type=template&id=4bb11d54"
import script from "./UsersGroupIcon.vue?vue&type=script&lang=js"
export * from "./UsersGroupIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports